/* eslint-disable */
import { PartnerTokenListTokenDto, fixPartnerTokenListTokenDtoFromJson, fixPartnerTokenListTokenDtoToJson } from '../dto/partner-token-list-token-dto';

export interface PartnerTokenListResponseDto {
  items: PartnerTokenListTokenDto[];
}

export const fixPartnerTokenListResponseDtoFromJson = (dto?: PartnerTokenListResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.items?.forEach((x, i, a) => fixPartnerTokenListTokenDtoFromJson(a[i]));
};

export const fixPartnerTokenListResponseDtoToJson = (dto?: PartnerTokenListResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.items?.forEach((x, i, a) => fixPartnerTokenListTokenDtoToJson(a[i]));
};
